import React, { useState } from "react";
import api from "@/lib/api";
import { useRecurso, MSG_SEM_RECURSO } from "@/lib/recursos";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FileText, FileSpreadsheet, Users, Banknote, CheckCheck, TrendingUp, Wallet, AlertTriangle, Handshake } from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { tipo: "clientes", label: "Clientes", desc: "Lista completa de clientes cadastrados", icon: Users },
  { tipo: "emprestimos_ativos", label: "Empréstimos Ativos", desc: "Contratos em andamento com saldo", icon: Banknote },
  { tipo: "emprestimos_finalizados", label: "Empréstimos Finalizados", desc: "Contratos quitados", icon: CheckCheck },
  { tipo: "valores_emprestados", label: "Valores Emprestados", desc: "Total liberado e saldo em aberto", icon: TrendingUp },
  { tipo: "valores_recebidos", label: "Recebimentos por Período", desc: "Pagamentos registrados no intervalo", icon: Wallet, dated: true },
  { tipo: "parcelas_vencidas", label: "Parcelas Vencidas", desc: "Todas as parcelas em atraso", icon: AlertTriangle },
  { tipo: "acordos", label: "Acordos de Renegociação", desc: "Acordos, valores renegociados e status de assinatura", icon: Handshake, dated: true },
];

export default function Reports() {
  const temRelatorios = useRecurso("relatorios");
  const [dfrom, setDfrom] = useState("");
  const [dto, setDto] = useState("");

  const download = async (tipo, formato) => {
    try {
      const resp = await api.get(`/reports/${tipo}?formato=${formato}&dfrom=${dfrom}&dto=${dto}`, { responseType: "blob" });
      const url = URL.createObjectURL(resp.data);
      if (formato === "pdf") {
        window.open(url, "_blank");
      } else {
        const a = document.createElement("a");
        a.href = url; a.download = `${tipo}.xlsx`; a.click();
      }
      toast.success("Relatório gerado!");
    } catch { toast.error("Erro ao gerar relatório"); }
  };

  return (
    <div className="space-y-5 fade-up" data-testid="reports-page">
      <div><h1 className="text-2xl font-extrabold tracking-tight">Relatórios</h1><p className="text-slate-500 text-sm">Exporte dados em PDF ou Excel.</p></div>
      {!temRelatorios && <div className="rounded-lg border border-amber-300 bg-amber-50 text-amber-900 text-sm px-3 py-2" data-testid="sem-recurso-relatorios">{MSG_SEM_RECURSO}</div>}

      <div className="trt-card p-4 flex gap-4 flex-wrap items-end">
        <div><Label className="text-xs">Data inicial (para recebimentos)</Label><Input type="date" value={dfrom} onChange={(e) => setDfrom(e.target.value)} className="mt-1" data-testid="report-dfrom" /></div>
        <div><Label className="text-xs">Data final</Label><Input type="date" value={dto} onChange={(e) => setDto(e.target.value)} className="mt-1" data-testid="report-dto" /></div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map((r) => (
          <div key={r.tipo} className="trt-card p-5" data-testid={`report-card-${r.tipo}`}>
            <r.icon className="w-6 h-6 gold-text mb-3" />
            <h3 className="font-bold">{r.label}</h3>
            <p className="text-sm text-slate-500 mt-1 mb-4">{r.desc}</p>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" disabled={!temRelatorios} title={temRelatorios ? "" : MSG_SEM_RECURSO} onClick={() => download(r.tipo, "pdf")} className="flex-1 gap-1" data-testid={`report-pdf-${r.tipo}`}>
                <FileText className="w-4 h-4" /> PDF
              </Button>
              <Button size="sm" disabled={!temRelatorios} title={temRelatorios ? "" : MSG_SEM_RECURSO} onClick={() => download(r.tipo, "excel")} className="flex-1 gap-1 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={`report-excel-${r.tipo}`}>
                <FileSpreadsheet className="w-4 h-4" /> Excel
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
